import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '../biLogger/BiLogger.context';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import AuthorWatchButton from '../Button/AuthorWatchButton';
import ContentStatistic from '../ContentStatistic';
import s from './SubmissionDetails.actionbar_phase_1.scss';
var SubmissionDetails = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, author = _b.author, title = _b.title, isOwner = _a.isOwner, showTitle = _a.showTitle;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['left'] },
            React.createElement(BiLoggerContextProvider, { value: { sectionname: 'author' } },
                author && (React.createElement(UserAvatar, { withTooltip: true, user: author, className: s['avatar'] })),
                React.createElement("div", { className: s['title-block'] },
                    title && showTitle && (React.createElement("div", { className: classnames(s['title'], title.length > 20 && s['long']) }, title)),
                    author && (React.createElement("div", { className: s['author'] },
                        React.createElement("span", { className: s['by'] },
                            t('deviation.details.by'),
                            " "),
                        React.createElement(UserLink, { className: s['username'], withTooltip: true, user: author }),
                        !isOwner && (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: s['pipe'] }, "\u00A0\u00A0\u00A0|\u00A0\u00A0\u00A0"),
                            React.createElement(AuthorWatchButton, { author: author })))))))),
        React.createElement(ContentStatistic, { deviation: deviation })));
};
SubmissionDetails.displayName = 'SubmissionDetails';
export default SubmissionDetails;
//# sourceMappingURL=SubmissionDetails.actionbar_phase_1.js.map